const messages = {
    // fallbackLng
    pt: {
        // ns e defaultNS 
        translations: {
            titles: {
                homeTitle: 'Aqcion'
            },
            navbar: {
                op1: 'Home',
                op2: 'Cliente', 
                op3: 'Time', 
                op4: 'Contato',
                op5: 'Páginas',
                    op6: 'Aqcion Blog',
            },
            homeMessages: {
                homeText: 'Seja bem-vindo à nossa empresa de desenvolvimento de projetos e sites, fundada em 2023 com o objetivo de fornecer soluções digitais de alta qualidade para nossos clientes.',
                homeText2: 'Nós somos uma equipe apaixonada por tecnologia e inovação, e estamos sempre buscando as melhores práticas e as últimas tendências do mercado para oferecer serviços de excelência.'
            },
            servicosMessages: {
                text1: 'Serviços',
                text2: 'Oferecemos',
                text3: 'Com a crescente popularidade do QR Code em todo o mundo, é importante contar com uma empresa especializada nessa tecnologia para garantir que seus projetos sejam executados com eficiência e qualidade. Com nossa tecnologia em QR Code oferecemos serviços especializados em criar soluções inovadoras e práticas para empresas e usuários finais. Com isso, é possível implementar estratégias eficazes de marketing, aumentar a segurança e otimizar processos.',
                
                titleservicos1: 'Projetos',
                textservicos1: 'Garantimos atingir metas, ideias e suas expectativas de sucesso.',
                
                titleservicos2: 'Treinamentos',
                textservicos2: 'Oferecemos treinamentos de manuseio e manutenção juntamente com treinamento de software.',

                titleservicos3: 'Tecnologia',
                textservicos3: 'Trazemos ao cliente tecnologias avançadas e dentro do mercado atual.',

                titleservicos4: 'Suporte',
                textservicos4: 'Temos suporte para nossos serviços, treinamento ao cliente e atendimento direto.',
            },
            notaMessages: {
                text1: 'hashtags',
                text2: 'Aqcion Digital',

                textparagrafo1: 'Nós entendemos que cada cliente tem necessidades únicas, e por isso oferecemos um atendimento personalizado e focado nas necessidades específicas de cada projeto. Desde a concepção da ideia até a entrega final do produto, trabalhamos em estreita colaboração com nossos clientes para garantir que as soluções que desenvolvemos atendam às suas expectativas e necessidades.',
                textparagrafo2: 'Nossa equipe também fornece serviços de manutenção, garantindo que os projetos e sites permaneçam atualizados e funcionando sem problemas. Realizamos testes regulares para garantir que tudo esteja funcionando perfeitamente e resolvemos quaisquer problemas que possam surgir.',
                textparagrafo3: 'Além disso, oferecemos serviços de treinamento para que nossos clientes possam manter seus sites e projetos atualizados e em pleno funcionamento. Com treinamentos personalizados, nossos clientes têm a oportunidade de aprender as habilidades necessárias para gerenciar e atualizar seus próprios projetos, tornando-se mais autônomos e reduzindo custos com manutenção.',
                textparagrafo4: 'Estamos comprometidos em fornecer soluções digitais de qualidade que atendam às necessidades de nossos clientes e, ao mesmo tempo, superem suas expectativas. Entre em contato conosco para saber mais sobre nossos serviços e como podemos ajudá-lo a alcançar seus objetivos digitais.',
            },
            faq: {
                title: 'FAQ',
                subtitle: 'Alguma pergunta?',
                text: 'Aqui estão algumas perguntas que recebemos frequentemente já respondidas para você.',

                pergunta1: 'A Aqcion oferece treinamento e suporte para soluções software?',
                resposta1: 'Oferecemos treinamento e suporte para soluções de software para ajudá-los a aprender a manusear de maneira eficaz e eficiente. Também fornecemos suporte técnico contínuo para garantir que o software esteja funcionando corretamente e ajudamos a resolver quaisquer problemas que possam surgir.',

                pergunta2: 'E como funciona a lei LGPD?',
                resposta2: 'Seguimos as diretrizes estabelecidas pela Lei Geral de Proteção de Dados (LGPD), adotamos medidas técnicas e organizacionais adequadas para garantir a proteção dos dados pessoais.',

                pergunta3: 'Vou ter minhas expectativas alcançadas?',
                resposta3: 'A Aqcion Digital garante que suas expectativas sejam alcançadas, para isso, seguimos algumas boas práticas, tais como a de compreender as necessidades do cliente, comunicação clara sobre o processo a ser feito, estabelecimento de metas, entre outras.',

                pergunta4: 'Como a Aqcion se mantém atualizada com as últimas tendências tecnológicas?',
                resposta4: 'Investimos em pesquisas e desenvolvimento para novas tecnologias e aprimorar as existentes, mantendo-se dentro do mercado de trabalho junto com profissionais qualificados para gerenciar e implementar tecnologias de ponta.',

                pergunta5: 'Por que QRCode e IA?',
                resposta5: 'Uma empresa inovadora utiliza QR code e inteligência artificial para oferecer uma experiência de compra mais eficiente e personalizada aos seus clientes.',

                pergunta6: 'A Aqcion é confiável?',
                resposta6: 'Demonstramos capacidade de cumprir com nossas obrigações e promessas aos clientes, somos uma empresa de total transparência e mente aberta para uma comunicação de maneira clara e oferecemos um trabalho de total qualidade!',
            },
            feedbacks: {
                title: 'Feedbacks',
                subtitle: 'O que nossos clientes dizem sobre nós',
                text: 'O essencial para a nossa forma de trabalhar é o nosso foco na construção de relações fortes com os nossos clientes.',

                feed1: '“Estou muito impressionado com o trabalho da empresa Aqcion Digital. Eles desenvolveram um website personalizado para minha empresa que é fácil de usar e melhorou significativamente nossa eficiência operacional. A equipe foi profissional e trabalhou comigo para garantir que o aplicativo atendesse às minhas necessidades específicas.',
                feed2: '“O processo de desenvolvimento foi muito suave e a equipe de desenvolvimento foi muito responsiva às nossas necessidades. Não poderíamos estar mais satisfeitos com o resultado final.',
                feed3: '“Eles foram muito acessíveis durante todo o processo de desenvolvimento e fizeram um ótimo trabalho ao manter-nos atualizados sobre o progresso do projeto. Recomendo a todos que precisam de serviços de desenvolvimento de tecnologia.',

                tecnologias: 'Algumas tecnologias que usamos ',
            },
            ceo: {
                title: 'CEO',
                subtitle: 'Time',
                text: 'Equipe de Desenvolvedores e Fundadores da Aqcion Digital.',

                nome1: 'Luiz Felipe Menezes',
                cargo1: 'Gerente de Pesquisa e Desenvolvimento',

                nome2: 'Thaiza Favarelli',
                cargo2: 'Developer FullStack',

                nome3: 'Gustavo Nonato',
                cargo3: 'Gerente de Mídias Sociais e Publicidade e Propaganda',
            },
            contato: {
                title: 'CONTATE-NOS',
                text1: 'Entre em contato!',
                text2: 'Tire dúvidas e faça um orçamento.',
                text3: 'Como podemos ajudar?',
                email: 'aqciondigi@gmail.com',

                titleforms: 'Envie-nos uma mensagem',
                lblnome: 'Nome completo*',
                lblemail: 'Email*',
                lblPhone: 'Número para contato*',
                lblmensagem: 'Mensagem*',
                btnenviar: 'Enviar mensagem',
            },
            footer: {
                text: 'Transformamos ideias em inovação tecnológica, impulsionando o presente e criando o futuro!',
                tecnologia: 'Tecnologias de desenvolvimentos',
                by: 'Designer e desenvolvimento de',
            },
            pageblog: {
                title1: 'Ferramentas de desenvolvimento',
                text1: 'Na nossa empresa, estamos sempre em busca das tecnologias mais avançadas para o desenvolvimento de projetos incríveis. Utilizamos uma variedade de ferramentas e tecnologias de ponta, garantindo resultados excepcionais para nossos clientes.',
                
                title2: 'Algumas tecnologias utilizadas',
                text2: '✨ Uma das nossas principais tecnologias é o Firebase, que nos permite criar aplicativos web e mobile com recursos poderosos de armazenamento em nuvem, autenticação de usuários e notificações em tempo real. Com ele, oferecemos uma experiência ágil e segura aos usuários dos nossos produtos.',
                text3: '💻 Além disso, contamos com o React e o FlutterFlow, frameworks de desenvolvimento de interfaces que nos permitem criar interfaces modernas e responsivas para nossos aplicativos. Com eles, garantimos uma experiência de usuário fluida, independente da plataforma utilizada.',
                text4: '🌐 Para o desenvolvimento do nosso backend, confiamos no Django e no MySQL. Com essas tecnologias robustas, criamos sistemas escaláveis, seguros e eficientes, capazes de lidar com grandes volumes de dados e garantir a estabilidade das nossas aplicações.',
                text5: '💰 Para as transações financeiras online, utilizamos o Stripe, uma plataforma segura e confiável de pagamentos eletrônicos. Isso nos permite oferecer uma experiência de compra tranquila e segura para os nossos clientes, aumentando a confiança e a satisfação.',
                text6: '⚡ E, por fim, para o desenvolvimento do frontend, contamos com o Tailwind e o HTML, que nos permitem criar layouts responsivos e estilos personalizados, garantindo uma aparência moderna e atraente para os nossos aplicativos e websites.',
                text7: '#tecnologiaavançada #desenvolvimentodeprojetos #inovação #experiênciadousuário #resultadosexcepcionais',
                text8: '🚀 Com essa gama de tecnologias avançadas, estamos prontos para desenvolver projetos incríveis e oferecer soluções inovadoras aos nossos clientes. Entre em contato conosco e descubra como podemos impulsionar o seu negócio para o próximo nível!',
            
                fraseaqcion: 'A vida é melhor para aqueles que fazem o possível para ter o melhor.',
            
                cardtext1: 'Fique por dentro de projetos inovadores!',
                cardtext2: 'Faça sempre bom uso da tecnologia.',
            
                fraseaqcion2: 'Transformamos ideias em realidade, impulsionando o potencial digital para conquistar o futuro.',
            
                topictitle1: 'Missão',
                topictitle2: 'Visão',
                topictitle3: 'Valores',

                topicname1: 'Soluções tecnológicas',
                topicname2: 'Reconhecimento',
                topicname3: 'Foco, valorização, inovação, qualidade',

                topictext1: 'Desenvolver soluções tecnológicas inovadoras e personalizadas para atender às necessidades dos nossos clientes. Superar as expectativas dos clientes e contribuir para o sucesso deles. Além disso, também oferecer treinamentos para capacitar os clientes a utilizar as nossas soluções de forma eficiente.',
                topictext2: 'A Aqcion Digital tem como visão ser reconhecida como referência no mercado de desenvolvimento de tecnologias personalizadas, com qualidade e excelência.',
                topictext3: 'Nossa empresa prioriza a excelência no atendimento aos clientes, com foco, trabalho em equipe e transparência. Buscamos qualidade e inovação em todas as etapas do desenvolvimento, proporcionando soluções criativas e disruptivas para uma vantagem competitiva.',
            },
            idioma: {
                text: 'Selecione um idioma',
            },
            maps: {
                title: 'Suporte técnico:',
                suporte: '19 99423-8412',
                email: 'aqciondigi@gmail.com',
                text1: 'Reporte bugs e tire dúvidas.',
                text2: 'Faça um orçamento!',
                endereco : 'Local: Av. Brasil Sul, 2001 - Parque Res. Nardini, Americana - SP, 13465-770',
            }
        }
    }
}

export { messages }